import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Subscription Plans',
      description: 'Configure pricing tiers, features, and free minutes.',
      icon: '💳',
      action: () => navigate('/admin/plans'),
      cta: 'Manage plans →',
      disabled: false,
    },
    {
      title: 'Email Templates',
      description: 'Manage transactional emails, previews, and newsletters.',
      icon: '📧',
      action: () => navigate('/admin/email-templates'),
      cta: 'Open templates →',
      disabled: false,
    },
    {
      title: 'Email Logs',
      description: 'Audit every send attempt with rendered previews and errors.',
      icon: '📬',
      action: () => navigate('/admin/email-logs'),
      cta: 'View logs →',
      disabled: false,
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <div className="adm-shell adm-shell-home">
      <header className="adm-header">
        <div className="adm-logo">
          <span className="adm-logo-icon">🛡️</span>
          <span>Admin Dashboard</span>
        </div>
        <div className="adm-header-right">
          <span className="adm-header-badge">Navigation Hub</span>
          <button className="adm-logout" onClick={handleLogout}>
            Logout →
          </button>
        </div>
      </header>

      <main className="adm-home">
        <section className="adm-hero">
          <div>
            <p className="adm-kicker">Admin Access</p>
            <h1 className="adm-hero-title">Choose where to work next.</h1>
            <p className="adm-hero-sub">
              Manage subscription plans, email templates, and audit every send from one place.
            </p>
          </div>
        </section>

        <section className="adm-card-grid">
          {cards.map((card) => (
            <button
              key={card.title}
              className={`adm-nav-card ${card.disabled ? 'adm-nav-card-disabled' : ''}`}
              onClick={card.action || undefined}
              disabled={card.disabled}
              type="button"
            >
              <span className="adm-nav-icon">{card.icon}</span>
              <span className="adm-nav-title">{card.title}</span>
              <span className="adm-nav-desc">{card.description}</span>
              <span className={`adm-nav-link ${card.disabled ? 'muted' : ''}`}>
                {card.cta}
              </span>
            </button>
          ))}
        </section>
      </main>
    </div>
  );
};

export default AdminDashboard;